/**
 * Created by DynamicDog on 2016-12-03.
 *
 * The main application class/component
 */
import {OnInit,Component,enableProdMode} from '@angular/core';
import {EtikettService} from "./services/etikett.service";
import {ActivatedRoute, Params}  from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
var $ = window['$'];
enableProdMode( )
@Component({
    selector: 'my-app',
    template: ` <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
<meta http-equiv="Pragma" content="no-cache">
<meta http-equiv="Expires" content="0"><div class="body-content">
                <!--app-header></app-header-->
                <intro-view></intro-view>
                <div *ngIf="etikettService.mode==='create' && etikettService.project.etiketter.length > 0">
                    <etikett-view></etikett-view>
                    <print-view></print-view>
                </div>
                <div *ngIf="etikettService.mode==='upload'">
                    <upload-view></upload-view>
                </div>
                <app-footer></app-footer>
                </div>
                <!--router-outlet></router-outlet-->
                `
})

export class AppViewComponent/* implements OnInit*/ {
    constructor(private etikettService:EtikettService) {

    }

}



// WEBPACK FOOTER //
// ./app/app.view.component.ts